import { connect } from 'react-redux';
import LogoCounty from '../components/LogoCounty';
import withTranslate from '../components/withTranslate';

const mapStateToProps = ({ branding }) => ({
  countyName: branding.name,
});

export default withTranslate(connect(mapStateToProps, null)(LogoCounty));
